import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="savings"
export default class extends Controller {

  initialize() {
    this.boundSavingsUpdated = this.savingsUpdated.bind(this)
  }

  connect() {
    this.billId = this.element.getAttribute("data-bill-id");
    this.updating = false;
    document.addEventListener('savingsUpdated', this.boundSavingsUpdated);
  }

  disconnect() {
    document.removeEventListener('savingsUpdated', this.boundSavingsUpdated)
  }

  savingsUpdated() {
    if (this.updating) {
      return;
    }
    this.updating = true;

    // Start the request after a short delay.  This helps when we initially parse the 
    // bill and there are LOTS of updates to the total savings in a short span.
    setTimeout(() => {
      $.ajax({
        type: 'GET',
        url: '/v2/bills/' + this.billId + '/savings',
        success: (response) => {
          const oldFormattedSavings = this.element.innerText;
          const oldSavings = Number(oldFormattedSavings.replace(/[^0-9.-]+/g,""));;
          const newSavings = Number(response.savings);
          this.animateSavings(oldSavings, newSavings);
          this.updating = false;
        },
        error: (xhr, textStatus, errorThrown) => {
          this.updating = false;
          // TODO
        }
      });
    }, 500);
  }

  animateSavings(oldSavings, newSavings) {
    // Animate the numbers changing from old price to new price.
    var steps = 30;
    var amountPerStep = (newSavings - oldSavings) / steps;
    var currentStep = 0;
    var interval = setInterval(() => {
      var currentAmount = oldSavings + (currentStep * amountPerStep);
      // Make sure the last step reaches the correct final price (no rounding errors)
      if (currentStep == steps - 1) {
        currentAmount = newSavings;
        clearInterval(interval);
      }
      this.element.innerText = this.formatPrice(currentAmount);
      currentStep += 1;
    }, 50);
  }

  formatPrice(price) {
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return formatter.format(price);
  }
}
